import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  getCustomQuery,
  getCustomReports,
} from "../../../../actions/Utilities/CustomReport";

export const useGetCustomReports = () => {
  return useQuery("GetCustomReports", getCustomReports, {
    refetchOnWindowFocus: false,
  });
};
